import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BackButton from '../components/BackButton';

function mapStateToProps(state) {
    return {
        historyEntries: state.app.historyEntries,
    };
}

export default withRouter(connect(mapStateToProps)(BackButton));
